// Global JavaScript - Team Line Custom Theme

/**
 * Initialize lazy-loaded images
 * Adds 'is-loaded' class when images finish loading
 */
function initLazyImages() {
  // Handle all images with loading="lazy"
  const lazyImages = document.querySelectorAll('img[loading="lazy"]');
  
  lazyImages.forEach(img => {
    // If already loaded, add class immediately
    if (img.complete && img.naturalHeight > 0) {
      img.classList.add('is-loaded');
    } else {
      // Add load listener
      img.addEventListener('load', function() {
        this.classList.add('is-loaded');
      }, { once: true });
      
      // Handle errors - still show the broken image placeholder
      img.addEventListener('error', function() {
        this.classList.add('is-loaded');
      }, { once: true });
    }
  });
  
  // Use MutationObserver to handle dynamically added images
  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { // Element node
          // Check if the node itself is an image
          if (node.tagName === 'IMG' && node.loading === 'lazy') {
            setupImageLoadHandler(node);
          }
          // Check for images inside the added node
          const innerImages = node.querySelectorAll ? node.querySelectorAll('img[loading="lazy"]') : [];
          innerImages.forEach(setupImageLoadHandler);
        }
      });
    });
  });
  
  observer.observe(document.body, { childList: true, subtree: true });
}

/**
 * Setup load handler for a single image
 */
function setupImageLoadHandler(img) {
  if (img.complete && img.naturalHeight > 0) {
    img.classList.add('is-loaded');
  } else {
    img.addEventListener('load', function() {
      this.classList.add('is-loaded');
    }, { once: true });
    
    img.addEventListener('error', function() {
      this.classList.add('is-loaded');
    }, { once: true });
  }
}

/**
 * Fallback: Make all images visible after a short delay
 * This ensures images are never permanently hidden
 */
function ensureImagesVisible() {
  setTimeout(() => {
    document.querySelectorAll('img[loading="lazy"]:not(.is-loaded)').forEach(img => {
      img.classList.add('is-loaded');
    });
  }, 3000); // 3 second fallback
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    initLazyImages();
    ensureImagesVisible();
  });
} else {
  initLazyImages();
  ensureImagesVisible();
}

// Export for use in other modules
window.TeamLine = window.TeamLine || {};
window.TeamLine.initLazyImages = initLazyImages;
